import React from "react";
import PropTypes from "prop-types";
import "./styles.less";
import "./prism-custom.css";

const Layout = props => {
    return (
        <>
            <main>{props.children}</main>
            {}
        </>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired
};

export default Layout;
